<template>
  <div>
    <div v-for="company in results" class="search_result" :key="company.resource_id">
    	<div class="flex flex_align_center">
    		<p><b>חברה:</b></p>
    		<div class="horizontal_space"></div>
			<link-entity :payload="company" :additional_data="{ resource_type: 'Company' }"></link-entity>
    		<div class="horizontal_space"></div>
			<p>(<b>אימייל</b>: {{company.email}})</p>
    	</div>
    </div>
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'
export default {
  name: 'search-modal-companies',
  props: ['results'],
  components: {
  	LinkEntity
  }
}
</script>
<style>
  .search_result {
    cursor: unset !important;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
</style>
